// Реквизиты организации для страниц Контакты и Оплата (требования банка)
export const contactLegalData = [
  { name: "Название компании", value: "ИП Чертова Ирина Сергеевна" },
  { name: "ИНН / КПП", value: "772853393707 / 770943002" },
  { name: "ОГРН", value: "326774600022315" },
  {
    name: "Банковские реквизиты",
    value: (
      <span className="bank-details">
        р/с 40802810000810217390<br />
        ФИЛИАЛ «ЦЕНТРАЛЬНЫЙ» БАНКА ВТБ (ПАО)<br />
        БИК 044525411<br />
        к/с 30101810145250000411
      </span>
    ),
  },
  { name: "Юридический адрес", value: "108826, Россия, г Москва, р-н Коммунарка, пр-кт Куприна, д. 24, корп. 1" },
  { name: "Телефон", value: "+7 (916) 923-71-45" },
  {
    name: "E-mail",
    value: <a href="mailto:chertovai@mail.ru">chertovai@mail.ru</a>,
  },
];
